import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_LOGIN: IntlKeyValuePair = {
    key: "login",
    defaultValue: "Login",
    intlValue: "Login",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_EMAIL: IntlKeyValuePair = {
    key: "email",
    defaultValue: "Email",
    intlValue: "Email",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_PASSWORD: IntlKeyValuePair = {
    key: "password",
    defaultValue: "Password",
    intlValue: "Password",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_DONT_HAVE_ACCOUNT: IntlKeyValuePair = {
    key: "dontHaveAccount",
    defaultValue: "Don’t have an account? ",
    intlValue: "Don’t have an account? ",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_SIGNUP: IntlKeyValuePair = {
    key: "signup",
    defaultValue: "Sign up",
    intlValue: "Sign up",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_FORGOT_PASSWORD: IntlKeyValuePair = {
    key: "forgotPassword",
    defaultValue: "Forgot your password?",
    intlValue: "Forgot your password?",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_SIGNIN: IntlKeyValuePair = {
    key: "signin",
    defaultValue: "Sign in",
    intlValue: "Sign in",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_CONTINUE_WITH_EMAIL: IntlKeyValuePair = {
    key: "continueWithEmail",
    defaultValue: "Or continue with email",
    intlValue: "Or continue with email",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_SIGN_IN_GOOGLE: IntlKeyValuePair = {
    key: "signInGoogle",
    defaultValue: "Sign in with Google",
    intlValue: "Sign in with Google",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_SIGN_IN_GOOGLE_ERROR: IntlKeyValuePair = {
    key: "signInGoogleError",
    defaultValue: "We couldn't sign you in with Google. Please try again.",
    intlValue: "We couldn't sign you in with Google. Please try again.",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_SHOW_PASSWORD: IntlKeyValuePair = {
    key: "showPassword",
    defaultValue: "Show password, your password is hidden",
    intlValue: "Show password, your password is hidden",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_HIDE_PASSWORD: IntlKeyValuePair = {
    key: "hidePassword",
    defaultValue: "Hide password, your password is visible",
    intlValue: "Hide password, your password is visible",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_WELCOME_BACK: IntlKeyValuePair = {
    key: "welcomeBack",
    defaultValue: "Welcome back!",
    intlValue: "Welcome back!",
    namespace: IntlNamespaces.LOGIN,
};

export const INTL_CREATE_ACCOUNT: IntlKeyValuePair = {
    key: "createAccount",
    defaultValue: "Create an account",
    intlValue: "Create an account",
    namespace: IntlNamespaces.LOGIN,
};
